import React from 'react';
import clsx from 'clsx';
import TriggerRenewalsContent from 'components/trigger-renewals/TriggerRenewalsTable';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { createStyles } from '../../globalStyles';

const TriggerRenewalsPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
      <PageHeader title="Trigger Renewals" />
      <TriggerRenewalsContent />
    </div>
  );
};

export default TriggerRenewalsPage;
